import { IBootstrapAnonymousSettings, IBootstrapCatalog } from './AndromeTV.types';

export class AnonymousSettings {
  catalogs?: IBootstrapCatalog[];
  defaultCatalogId?: string;
  defaultProfileId?: string;
  defaultEntitlementId?: string;
  defaultParentalId?: string;

  constructor(settings?: IBootstrapAnonymousSettings) {
    this.catalogs = settings?.catalogs;
    this.defaultCatalogId = settings?.defaultCatalogId;
    this.defaultProfileId = settings?.defaultProfileId;
    this.defaultEntitlementId = settings?.defaultEntitlementId;
    this.defaultParentalId = settings?.defaultParentalId;
  }
}
